import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';
import { useAuth } from "../providers/AuthProvider.jsx";

function ProfileModal({setIsProfileOpen, setIsDepositOpen, setIsWithdrawOpen}) {
    const { user, setUser } = useAuth()
    const [userWallet, setUserWallet] = useState(null)
    const [verify, setVerify] = useState(null)
    const [uzsBalance, setUzsBalance] = useState(0.00)
    const [usdBalance, setUsdBalance] = useState(0.00)
    const [rubBalance, setRubBalance] = useState(0.00)
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        if(user) {
            setUserWallet(user.mainWallet)
            setVerify(user.verify)
            setUzsBalance(user.uzsBalance)
            setUsdBalance(user.usdBalance)
            setRubBalance(user.rubBalance)
        }
    }, [user])

    const formatNumber = (number) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(number);
      };


      const setMainWalletFetch = async (requestData) => {
        setIsLoading(true)
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/set-main-wallet`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ setWallet: requestData}),
            })


            if (response.ok) {
                const data = await response.json();
                setIsLoading(false)
              } else {
                const errorData = await response.json();
                
              }
        } catch (error) {
            
        }
      }

    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsProfileOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{t("mp_profile")}</span>
                </div>
                <div className={'profile-modal-wallets-container'}>
                    <div className={'p-modal-wallets-title'}>
                        {t("mp_my_wallets")}
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p>UZS</p>
                        <div className={'p-modal-wallet-wall'}></div>
                        <p className={'p-modal-wallet-amount'}>{formatNumber(uzsBalance)}</p>
                        <div className={`p-modal-wallet-switcher ${userWallet === 'uzs' ? "active" : ""}`} onClick={() => {
                            if(user.mainWallet === 'uzs') {
                                return
                            }
                            setUser((prev) => ({
                                ...prev,
                                mainWallet: 'uzs'
                            }))
                            setMainWalletFetch('uzs')
                        }}>
                            <div className={`p-modal-wallet-switcher-oval ${userWallet === 'uzs' ? "active" : ""}`}></div>
                        </div>
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p>USD</p><div className={'p-modal-wallet-wall'}></div>
                        <p className={'p-modal-wallet-amount'}>{formatNumber(usdBalance)}</p>
                        <div className={`p-modal-wallet-switcher ${userWallet === 'usd' ? "active" : ""}`} onClick={() => {
                            if(user.mainWallet === 'usd') {
                                return
                            }
                            setUser((prev) => ({
                                ...prev,
                                mainWallet: 'usd'
                            }))
                            setMainWalletFetch('usd')
                        }}>
                            <div className={`p-modal-wallet-switcher-oval ${userWallet === 'usd' ? "active" : ""}`}></div>
                        </div>
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p>RUB</p><div className={'p-modal-wallet-wall'}></div>
                        <p className={'p-modal-wallet-amount'}>{formatNumber(rubBalance)}</p>
                        <div className={`p-modal-wallet-switcher ${userWallet === 'rub' ? "active" : ""}`} onClick={() => {
                            if(user.mainWallet === 'rub') {
                                return
                            }
                            setUser((prev) => ({
                                ...prev,
                                mainWallet: 'rub'
                            }))
                            setMainWalletFetch('rub')
                        }}>
                            <div className={`p-modal-wallet-switcher-oval ${userWallet === 'rub' ? "active" : ""}`}></div>
                        </div>
                    </div>
                    <div className={'p-modal-buttons-container'}>
                        <div className={'p-modal-deposit-button'} onClick={() => {
                            setIsDepositOpen(true)
                            // setIsProfileOpen(false)
                        }}>
                            <img src="/assets/img/main/deposit-plus.svg" alt="" />
                            <p>{t("mp_deposit")}</p>
                        </div>
                        <div className={'p-modal-deposit-button withdraw'} onClick={() => {
                            setIsWithdrawOpen(true)
                        }}>
                            <img src="/assets/img/main/deposit-minus.svg" alt="" />
                            <p>{t("mp_withdraw")}</p>
                        </div>
                    </div>
                </div>
                <div className={'p-modal-personal-container'}>
                    <div className={'p-modal-personal-title'}>
                        <p>{t("mp_personal_data")}</p>
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p>UZ</p>
                        <div className={'p-modal-wallet-wall'}></div>
                        <p className={'p-modal-wallet-amount'}>{user ? "+" + user.phoneNumber : ""}</p>
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <img src="/assets/img/main/mail-p-modal.svg" alt="" />
                        <div className={'p-modal-wallet-wall'}></div>
                        <p className={'p-modal-wallet-amount'}>{user ? user.email : ""}</p>
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p className={'p-modal-personal-name'}>{t("mp_name")}</p>
                        <div className={'p-modal-wallet-wall'}></div>
                        {user && <p className={'p-modal-wallet-amount'}>{user.fullName ? user.fullName : ""}</p>}
                    </div>
                    <div className={'p-modal-wallet-container'}>
                        <p className={'p-modal-personal-name'}>{t("mp_birthday")}</p>
                        <div className={'p-modal-wallet-wall'}></div>
                        {user && <p className={'p-modal-wallet-amount'}>{user.dateOfBirth ? user.dateOfBirth : ""}</p>}
                    </div>
                </div>
                <div className={'p-modal-verify-container'}>
                    <p>{t("mp_verification_status")}</p>
                    {verify && <div className={'p-modal-wallet-container verify-container'}>
                        <p style={{"color": "white"}}>{t("mp_verify")}</p>
                    </div>}
                    {!verify && <div className={'p-modal-wallet-container verify-container unverify'}>
                        <p style={{"color": "white"}}>{t("mp_pass_verification")}</p>
                    </div>}
                </div>
                {isLoading && <div className={'modal-loader-wrapper'}>
                        <img src="/assets/img/main/loading.svg" alt="" />
                    </div>}
            </div>
        </div>
    )
}

export default ProfileModal;